export default __webpack_public_path__ + "static/media/cert-student-HKIRC.0064ab19.jpg";